const METRIC_ID = 20518312;

export const GOALS = {
  addToCart: "addToCart",
  confirm: "confirm",
} as const;
type GoalsType = keyof typeof GOALS;

export const reachGoal = (goal: GoalsType | CartGoalsType, user?: any) => {
  if (user?.IS_MANAGER || user?.IS_ADMIN) {
    return;
  }
  try {
    // @ts-ignore
    if (typeof ym !== "undefined") {
      // @ts-ignore
      ym(METRIC_ID, "reachGoal", goal);
    }
  } catch (e) {
    console.log("reachGoal error", e);
  }
};

export const CART_GOALS = {
  addToCart: "addToCart",
  cartStep1: "cartStep1",
  cartStep2: "cartStep2",
  cartStep3: "cartStep3",
  cartSuccess: "cartSuccess",
} as const;

type CartGoalsType = keyof typeof CART_GOALS;

export const reachCartGoal = (goal: CartGoalsType, user?: any) => {
  if (user?.IS_MANAGER || user?.IS_ADMIN) {
    return;
  }
  try {
    if (typeof sessionStorage === "object") {
      let existedSessionGoals = getExistedGoalsFromSession();
      if (
        goal === CART_GOALS.addToCart &&
        existedSessionGoals.includes(CART_GOALS.cartSuccess)
      ) {
        existedSessionGoals = [];
      }
      if (!existedSessionGoals.includes(goal)) {
        pushGoalsToSession([...existedSessionGoals, goal]);
        reachGoal(goal);
      }
    }
  } catch (e) {
    console.log("reachCartGoal error", e);
  }
};

function getExistedGoalsFromSession(): CartGoalsType[] {
  const existedSessionGoalsString = sessionStorage.getItem(
    "existedSessionGoals",
  );
  if (existedSessionGoalsString) {
    return existedSessionGoalsString.split(",") as CartGoalsType[];
  }
  return [];
}

function pushGoalsToSession(goals: CartGoalsType[]) {
  sessionStorage.setItem("existedSessionGoals", goals.join(","));
}
